import React from 'react'
import { ReactComponent as Chevron} from '../../../images/svg/arrow-right-chevron.svg'
import { CBButton } from './cbd'

import MediaQuery from 'react-responsive'
const CBModal = ({
  children,
  visible = false,
  onCancelClick,
  onMiddleClick,
  onPositiveClick,
  title,
  disabled,
  cancelLabel="Back",
  middleLabel,
  positiveLabel="OK",
  wide=false
}) => {

  function renderContent(){
   return <div className={`flex flex-col lg:p-8 bg-white shadow-sm rounded-sm w-full ${wide? 'lg:w-1/2' : 'lg:w-1/3'} p-8`}>
            <div className="font-sarabun text-lg">{title}</div>
            <div className="rounded-sm pt-4">
              {children}
            </div>
            <div className="flex gap-x-2 justify-end ">
              <div>
                <CBButton
                  
                  disabled={disabled}
                  // loading={disabled}
                  onClick={(e) => onCancelClick(false)}
                  type="ternary"
                >
                  {cancelLabel}
                </CBButton>
              </div>
              {middleLabel && <div>
                <CBButton
                  type="secondary"
                  disabled={disabled}
                  loading={disabled}
                  onClick={(e) => onMiddleClick(false)}
                >
                  {middleLabel}
                </CBButton>
              </div>}
              <div>
                <CBButton
                  icon={<Chevron></Chevron>}
                  disabled={disabled}
                  loading={disabled}
                  onClick={(e) => onPositiveClick(false)}
                >
                  {positiveLabel}
                </CBButton>
              </div>
            </div>
          </div>
  }
  return (
    <div >
      {visible ? (<>
        <MediaQuery maxDeviceWidth={1224}>
        <div className="fixed w-full h-full bg-gray-900 bg-opacity-70  p-2 left-0 top-0 z-10  overflow-y-auto flex justify-center items-center">
        
          {renderContent()}
          </div>
        </MediaQuery>
        <MediaQuery minDeviceWidth={1224}>
        <div className="pt-4 flex flex-col space-y-4 min-w-screen h-screen animated fadeIn faster  fixed bg-opacity-70 left-0 top-0 flex justify-center items-center inset-0 z-50 outline-none focus:outline-none bg-gray-900 overflow-y-scroll">
          {renderContent()}
        </div>
        </MediaQuery>
        </>
      ) : (
        <></>
      )}
    </div>
  )
}

export { CBModal }
